<template>
  <div>
    <vessel-trial-test-table
      :id="id"
      :trialName="vesselTrial.name"
    ></vessel-trial-test-table>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import ObjectType from '@/services/Objects.js'
import VesselTrialTestTable from '@/components/tables/VesselTrialTestTable.vue'

export default {
  name: 'VesselTrialTests',
  components: {
    VesselTrialTestTable
  },
  props: {
    id: String
  },
  data() {
    return {
      vesselTrial: ''
    }
  },
  created() {
    this.getTrial()
  },
  methods: {
    getTrial() {
      ApiService.get(ObjectType.VesselTrial, this.id).then(response => {
        this.vesselTrial = response.data
      })
    }
  }
}
</script>

<style scoped></style>
